import { getAddressConfirmation } from "../util/discovery";

export class RewardConfirmation {
    private static instance: RewardConfirmation;

    static getInstance(): RewardConfirmation {
        if (!RewardConfirmation.instance) {
            RewardConfirmation.instance = new RewardConfirmation();
        }
        return RewardConfirmation.instance;
    }
    constructor() {
        this.displayConfirmationDetails();
    }

    private displayConfirmationDetails(): void {
        const rewardConfirmationId = document.querySelector('#reward-confirmation');
        const rewardConfirmation = sessionStorage.getItem('rewardConfirmation');
        if (rewardConfirmationId && rewardConfirmation) {
            const parsedRewardConfirmation = JSON.parse(rewardConfirmation);
            const { contactInfo ,specialOffers,comment } = parsedRewardConfirmation;

            this.updateServiceAddress(parsedRewardConfirmation);
            this.updateContactInfo(contactInfo);
            this.updateSpecialOffers(specialOffers);
            this.updateComment(comment);
        }
    }

    private updateServiceAddress(parsedRewardConfirmation: string): void {
        const rewardAddress = document.querySelector('#reward_confirmation_address');
        let finalAddress: string;
        let obj = getAddressConfirmation(parsedRewardConfirmation);
        if (obj.line1 && obj.line2) {
            finalAddress = `${obj.line1} ${obj.line2}`;
        }
        else if (obj.line1) {
            finalAddress = `${obj.line1}`;
        }
        else if (obj.line2) {
            finalAddress = `${obj.line2}`;
        }
        else {
            finalAddress = ``;
        }
        if (finalAddress && rewardAddress) {
            rewardAddress.innerHTML = finalAddress;
        } else {
            rewardAddress?.closest('.appointment-item')?.classList.add('hidden');
        }
    }

    public testUpdateServiceAddress() {
        this.updateServiceAddress(JSON.stringify({Address2: 'Address 2'}));
    }

    private updateContactInfo(contactInfo: any): void {
        const rewardContact = document.querySelector('#reward_confirmation_contact');
        if(contactInfo && rewardContact){
            rewardContact.innerHTML = contactInfo?.name;

            const rewardContactEmailClone = rewardContact.cloneNode(true) as Element;
            rewardContactEmailClone.innerHTML = contactInfo?.email;

            const rewardContactPhonClone = rewardContact.cloneNode(true) as Element;
            rewardContactPhonClone.innerHTML = contactInfo?.phone;

            if (rewardContact.parentNode) {
                rewardContact.parentNode.appendChild(rewardContactEmailClone);
                rewardContact.parentNode.appendChild(rewardContactPhonClone);
            }

        }else {
            rewardContact?.closest('.appointment-item')?.classList.add('hidden');
        }
    }

    public testUpdateContactInfo() {
        this.updateContactInfo({name: 'FirstName LastName', email: 'testemail@gmail.com', phone: '1234567890'});
    }

    private updateSpecialOffers(specialOffers: string[]): void {
        const rewardSpecialOffers = document.querySelector('#reward_confirmation_offers');
        if(specialOffers?.length > 0 && rewardSpecialOffers){
            const rewardSepcialUlEle = document.createElement('ul');
            let htmlContent = '';

            specialOffers.forEach((offer: string) => {
                htmlContent += `<li class="icon-block-text">${offer}</li>`;
            });
    
            rewardSepcialUlEle.innerHTML = htmlContent;
            rewardSpecialOffers.after?.(rewardSepcialUlEle);
            
        }else{
            rewardSpecialOffers?.closest('.appointment-item')?.classList.add('hidden');
        }
    }

    public testUpdateSpecialOffers() {
        this.updateSpecialOffers(['Test Offer 1', 'Test Offer 2']);
    }

    private updateComment(comment: string): void {
        const rewardComment = document.querySelector('#reward_confirmation_description');
        if(comment && rewardComment){
            rewardComment.innerHTML = comment;
        }else{
            rewardComment?.closest('.appointment-item')?.classList.add('hidden');
        }
    }

    public testUpdateComment() {
        this.updateComment('Test Comment');
    }
}

// Initialize the RewardConfirmation class if dom-loader is not present
if (!(globalThis as any).__RewardConfirmationListenerAdded) {
  (globalThis as any).__RewardConfirmationListenerAdded = true;

  document.addEventListener('DOMContentLoaded', () => {
    // Prevent duplicate initialization if dom-loader already handled it
    if ((globalThis as any).__RewardConfirmationInitialized) return;

    const confirmationSection = document.querySelector('#reward-confirmation');
    if (confirmationSection) {
      (globalThis as any).__RewardConfirmationInitialized = true;
      RewardConfirmation.getInstance();
    }
  });
}